export default {
  content: {
    iosPromptPart1: "Zainstaluj aplikację na swoim iPhonie:<br /> stuknij ",
    iosPromptPart2: "a następnie <em>'Dodaj do ekranu początkowego.'</em>",
    bookingStatus: {
      statusNew: {
        label: "Oczekujący",
        desc: " Twoja rezerwacja została pomyślnie wysłana. Potrzebujemy odrobinę czasu, aby ją przejrzeć."
      },
      statusAccept: {
        label: "Zatwierdzony",
        desc: " Wspaniale! Twoja rezerwacja została zatwierdzona.",
        pickupText: "Nasz kierowca będzie na Ciebie czekał przed terminalem lotniska.",
        pickupTextDeparture: "Poinformujemy Cię o godzinie przyjazdu busa dzień przed odlotem około godz. 18:00."
      },
      statusReject: {
        label: "Odrzucony",
        desc: " Bardzo nam przykro, niestety musieliśmy odrzucić Twoją rezerwację.",
        moreInfo: "Aby uzyskać więcej informacji",
        contact: "skontaktuj się z nami"
      },
      statusCanceled: {
        label: "Anulowany",
        desc: " Twoja rezerwacja została anulowana. Dziękujemy za informację!",
        moreInfo: "Twoja płatność została zwrócona i powinna być na Twoim koncie w ciągu 10 dni roboczych.",
        infoWithoutRefund: 'Anulujesz mniej niż 8 godzin przed planowanym lotem. Nie otrzymasz zwrotu pieniędzy.',
      },
      statusAssigned: {
        descDeparture: "jest gotowy, by odebrać Cię jutro o",
        descTodayDeparture: "jest gotowy, by odebrać Cię dziś o",
        descNormal: "będzie oczekiwał przed terminalem lotniska.",
        contactInfo: "Możesz skontaktować się z nim",
        desc: " Poznaj swojego kierowcę.",
        label: "Gotowy"
      },
      statusCompleted: {
        desc: " Będziemy bardzo szczęśliwi, jeśli",
        review: 'zostawisz ocenę.',
        tripReview: 'Zostaw ocenę',
        label: "Zakończony",
        allDone: "Gotowe!",
        thanksForReview: 'Dziękujemy za opinię!',
      },
      statusNoShow: {
        moreInfo: "Jeśli anulujesz rezerwację, kierowca zostanie o tym powiadomiony.",
        desc: "(<span><strong>%driver%</strong> czekał na ciebie w umówionym miejscu.</span>)",
        label: "No show"
      },
    },
    layout: {
      header: {
        welcomeMessage: "Cześć! Miło znowu Cię widzieć.",
        registerMessage: "Cześć! Znamy się już?",
        registerSecondMessage: "Nie? W takim razie poznajmy się!",
        registerButton: "Zarejestruj się",
        helloAgainTitle: "Witaj ponownie!",
        logIn: "Zaloguj się",
        activeBookingCount: "<span>Masz </span> %count% nadchodząca rezerwacje"
      },
      landingLayout: {
        title: "Punktualnie i wygodnie",
        desc: "<span>Twoja podróż na lotnisko</span> nigdy nie była prostsza!",
        bookNow: "Zarezerwuj teraz!",
        questionsTitle: "Pytania?",
        poweredByStripe: "Powered by Stripe & iZettle®"
      },
      menuMain: {
        home: "Stona głowna",
        booking: "Rezerwacja",
        howItWorks: "Jak to działa",
        aiportTransfer: "Oslo Gardermoen",
        pricing: "Cennik",
        faq: "FAQ",
        contact: "Kontakt",
      },
      sidebarAndHeader: {
        dashboard: 'Przejazdy',
        booking: 'Rezerwacja',
        myAccount: 'Moje konto',
        help: 'Pomoc',
        editReservation: 'Edytuj rezerwację',
        backToEditTitle: 'Wróć do edycji rezerwacji',
        backToHelpTitle: 'Wróć do Pomoc',
        backToDashboardTitle: 'Wróć do Panelu',
      }
    },
    landing: {
      homepage: {
        mainpage: {
          title: "Transfery",
          subtitleFirst: "Lotniskowe",
          subtitleSecond: "Oslo Torp"
        },
        about: {
          headline: {
            title: "Prosty dojazd na lotnisko",
            description: "Zarezerwuj, jedź i leć!"
          },
          profits: {
            first: {
              title: "Prosta rezerwacja",
              description: "Wybierz lot do lub z lotniska Oslo Sandefjord Torp, a następnie dokonaj rezerwacji busa przez telefon lub stronę internetową. Odbierzemy Cię z domu, pracy lub lotniska, a dzień przed wylotem otrzymasz SMS z potwierdzeniem godziny przyjazdu busa. Zadzwonimy też na chwilę przed stawieniem się pod wskazany adres.",
              footer: "Jakieś pytania?",
              linkFaq: {
                preTitle: "Sprawdź nasze",
                title: "FAQ"
              },
              linkContact: {
                separator: " lub ",
                title: "Skontaktuj się z nami"
              }
            },
            second: {
              title: "Punktualny kierowca",
              description: "Bądź spokojny, nie spóźnisz się na samolot - już wcześniej ustalamy trasę tak, aby dowieźć Cię na lotnisko 1,5 godz. przed wylotem. A jeśli samolot z Polski będzie opóźniony, nasz kierowca będzie na Ciebie czekać przed halą przylotów.",
              footer: "Sprawdź status i wprowadź zmiany w rezerwacji.",
              linkTitle: "Stwórz konto"
            },
            third: {
              title: "Stała cena",
              description: "Wybierasz, jaki sposób płatności jest dla Ciebie najwygodniejszy. Opłaty możesz dokonać online lub gotówką/kartą dopiero u kierowcy. Żadnych ukrytych kosztów, zawsze wiesz, ile zapłacisz.",
              footer: "Ile płacę?",
              linkTitle: "Sprawdź ceny"
            },
          }
        },
        testimonials: {
          title: "Nasi zadowoleni klienci",
          description: "Jedź z nami i dołącz do nich",
          items: {
            first: {
              author: "Agnieszka H.",
              content: "Profesjonalnie, uprzejmie, punktualnie. Polecam!",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            second: {
              author: "Bartłomiej O.",
              content: "Dzień przed planowanym kursem otrzymaliśmy SMS z ;informacjami o godzinie 16:16. Prawie trzy godziny wcześniej niż było to planowane, także plus za to. Jeśli chodzi o samą podróż na lotnisko, to wszystko poszło sprawnie. Miły kierowca i zero opóźnień. Na lotnisku byliśmy dokładnie dwie godziny przed planowanym wylotem.",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            third: {
              author: "Michaela S.",
              content: "Dobry, szybki i niezawodny transport do Oslo Torp.",
              logoAlt: "Google",
              url: "google.com"
            },
            fourth: {
              author: "Mateusz S.",
              content: "Bus był w porządku. Kierowca miły, konkretny i sam kontaktował się z nami w sprawie odbioru. Przy przylocie nie sposób nie zauważyć busika na lotnisku. Polecam jako tańszą alternatywę.",
              logoAlt: "Google",
              url: "google.com"
            }
          },
          footer: {
            title: "Rezenzja z"
          }
        }
      },
      howItWorks: {
        title: "Jak to działa?",
        description: "Jedź z domu, dziel podróż z innymi pasażerami i płać mniej.",
        list: {
          first: {
            title: "Szybka rezerwacja",
            description: "Zarezerwuj bus przez stronę internetową lub zadzwoń do nas. Samochód PKS Oslo podjedzie gdzie tylko chcesz: pod dom, miejsce pracy lub lotnisko Oslo Torp."
          },
          second: {
            title: "Stały kontakt",
            description: "Jako zarejestrowany użytkownik możesz edytować zamówienie i śledzić jego status. Pozostajemy w kontakcie, dlatego dzień przed wylotem czekaj na SMS potwierdzający godzinę przyjazdu busa. Kierowca da też sygnał, kiedy podjedzie już na wskazane miejsce."
          },
          third: {
            title: "Pewny transport",
            description: "Jeśli Twój przylot jest opóźniony, nie martwisz się. Kierowca czeka na Ciebie przed halą przylotów lub na miejscu odbioru."
          },
          fourth: {
            title: "Wygodne płatności",
            description: "Płacisz jak chcesz. Możesz dokonać opłaty dopiero po przyjeździe kierowcy lub od razu za pośrednictwem aplikacji z dodaną wcześniej kartą płatniczą."
          }
        }
      },
      transferPage: {
        hero: {
          badge: "Transfer lotniskowy PKS Oslo",
          title: "Bezpośredni przejazd z Oslo na lotnisko Gardermoen",
          lede: "Odbierzemy Cię spod domu i dowieziemy pod terminal w 40–60 minut. Stała cena, mały bus i polskojęzyczna obsługa gwarantują spokojny start podróży.",
          kpi: {
            first: "<strong>od 260 NOK</strong> / osoba – bez ukrytych kosztów",
            second: "Maksymalnie <strong>3 adresy</strong> po drodze",
            third: "SMS z potwierdzeniem i godziną odbioru"
          },
          cta: "Zarezerwuj kurs",
          hint: "Rezerwacja min. 3 godziny przed lotem",
          imgAlt: "Kierowca PKS Oslo przed busem transferowym"
        },
        benefits: {
          title: "Dlaczego pasażerowie wybierają PKS Oslo?",
          subtitle: "Usługa zaprojektowana z myślą o wygodnym dojeździe na Gardermoen.",
          list: {
            first: {
              title: "🏠 Odbiór spod drzwi",
              description: "Kierowca przyjeżdża prosto pod wskazany adres i pomaga z bagażem. Nie martwisz się o przesiadki."
            },
            second: {
              title: "💳 Przejrzysta cena",
              description: "Stała stawka <strong>od 260 NOK / osoba</strong>. Płacisz za miejsce, nie za cały kurs jak w taxi."
            },
            third: {
              title: "🧳 Komfortowy bus",
              description: "Mały bus to maksymalnie trzech pasażerów po drodze i krótki czas przejazdu, bez tłoku i zbędnych postojów."
            }
          }
        },
        process: {
          title: "Jak wygląda transfer?",
          subtitle: "Trzy proste kroki – od rezerwacji do odprawy.",
          steps: {
            first: "<strong>Rezerwujesz przejazd</strong> online w kilka minut i wskazujesz adres odbioru.",
            second: "<strong>Dzień przed lotem otrzymujesz SMS</strong> z dokładną godziną przyjazdu kierowcy. Standardowy czas przejazdu to 40–60 minut.",
            third: "<strong>Kierowca odbiera Cię spod domu</strong> i wiezie bezpośrednio na lotnisko Gardermoen."
          }
        },
        comparison: {
          title: "PKS Oslo, Flybussen czy taxi?",
          subtitle: "Porównaj najpopularniejsze opcje dojazdu na lotnisko.",
          columns: {
            pks: "PKS Oslo",
            flybussen: "Flybussen",
            taxi: "Taxi"
          },
          rows: {
            pickup: {
              label: "Odbiór spod domu",
              pks: "✅ Tak",
              flybussen: "❌ Nie (przystanek)",
              taxi: "✅ Tak"
            },
            price: {
              label: "Cena",
              pks: "<strong>od 260 NOK / osoba</strong>",
              flybussen: "ok. 260 NOK / osoba",
              taxi: "~900–1200 NOK za kurs"
            },
            duration: {
              label: "Czas przejazdu",
              pks: "⏱️ 40–60 min",
              flybussen: "60–90 min",
              taxi: "⏱️ 40–60 min"
            },
            stops: {
              label: "Przystanki po drodze",
              pks: "<strong>Maks. 3 adresy</strong>",
              flybussen: "Wiele przystanków",
              taxi: "Brak (kurs prywatny)"
            },
            luggage: {
              label: "Bagaż",
              pks: "Pomoc przy załadunku, w cenie",
              flybussen: "W cenie",
              taxi: "W cenie"
            },
            language: {
              label: "Język obsługi",
              pks: "Polski",
              flybussen: "NO / EN",
              taxi: "NO / EN"
            }
          },
          disclaimer: "Szacunki kosztów taxi na podstawie typowych stawek w Oslo (mogą różnić się w zależności od firmy i pory)."
        },
        quotes: {
          title: "Co mówią pasażerowie?",
          first: {
            text: "„Kierowca przyjechał punktualnie, podróż była szybka i bez stresu. Polecam!”",
            cite: "— Kasia, Oslo"
          },
          second: {
            text: "„Dla naszej rodziny to najlepszy sposób na lotnisko: wygodnie, w świetnej cenie.”",
            cite: "— Piotr, Drammen"
          }
        },
        info: {
          title: "Transfer Oslo – lotnisko Gardermoen",
          first: "Szukasz wygodnego dojazdu na lotnisko Gardermoen? PKS Oslo to sprawdzony <strong>transfer z Oslo na lotnisko</strong> bez stresu i przesiadek. Odbieramy spod domu, a po drodze zatrzymujemy się maksymalnie pod trzema adresami. Kursujemy codziennie, dopasowując godziny odbioru do Twojego lotu.",
          second: 'Przejazd trwa zwykle <strong>40–60 minut</strong>, a rezerwacja zajmuje kilka kliknięć. Po złożeniu zamówienia otrzymasz potwierdzenie SMS oraz kontakt do kierowcy. Pytania? Zadzwoń pod <strong>+47 96 70 11 03</strong> lub napisz na <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
        }
      },
      faq: {
        title: "FAQ",
        description: "Lista najczęściej zadawanych pytań",
        generalTitle: "Ogólne",
        paymentTitle: "Płatność",
        accountTitle: "Moje konto",
        generalQuestions:
          [
            {
              title: 'Jak zarezerwować transfer lotniskowy?',
              paragraph: 'Rezerwacji na przejazd do lub z lotniska Sandefjord Torp możesz dokonać poprzez formularz na naszej stronie internetowej lub pod numerem telefonu <a href="tel:+4796701103">+47 96 70 11 03</a>. Powiedz nam tylko gdzie lecisz/skąd przylatujesz i skąd mamy Cię odebrać/gdzie zawieźć.'
            },
            {
              title: 'Gdzie mogę Was znaleźć na lotnisku?',
              paragraph: 'Nasz kierowca będzie czekał na Ciebie przed terminalem lotniska z niebieskim znakiem PKS Oslo. Wystarczy, że podejdziesz do niego, a on wskaże Ci miejsce w busie. <br /><br />Uwaga! Pamiętaj, aby po wylądowaniu włączyć telefon - nasz kierowca będzie się z Tobą kontaktował.'
            },
            {
              title: 'Czy oferujecie transfer lotniskowy na lotnisko Gardermoen?',
              paragraph: 'Nie oferujemy transferu zbiorowego na lotnisko Gardermoen. <br /><br /> Jeśli jesteście grupą 5 lub więcej osób możemy zapropować prywatny transfer. Skontaktujecie się z nami przez <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
            },
            {
              title: 'Nie mogę znaleźć swojego lotu.',
              paragraph: 'Jeśli Twój lot nie wyświetla się na naszej stronie oznacza to, że go nie obsługujemy. Jednakże, możesz dokonać rezerwacji na inny lot o podobnej godzinie. Będziemy na lotnisku 1,5 godz. przed odlotem.'
            },
            {
              title: 'O której godzinie będzie po mnie bus?',
              paragraph: 'Nie mamy ustalonych godzin odjazdu z lotniska, ponieważ świadczymy usługę door-to-door. Trasy są planowane z dziennym wyprzedzeniem. Wtedy też, około 18:00 otrzymasz od nas smsa z godziną przyjazdu busa pod wskazany adres. <br /><br />Jeśli nie odpowiada Ci godzina odjazdu, zawsze możesz anulować rezerwację nie ponosząc żadnych kosztów. Jeśli płaciłeś za przejazd online, pieniądze wrócą na Twoje konto do 10 dni roboczych'
            },
            {
              title: 'Jakie loty obsługujecie?',
              paragraph: 'Możesz znależć listę wszystkich lotów, które obsługujemy w naszej aplikacji. Jeśli nie znalazłeś swojego lotu, możesz dokonać rezerwacji na inny, o podobnej godzinie.'
            },
            {
              title: 'Czy mogę przesunąć rezerwację na inny dzień?',
              paragraph: 'Jeśli chcesz zmienić datę transportu, możesz anulować istniejącą rezerwację i utworzyć nową. Jeśli zapłaciłeś kartą z gòry, otrzymasz automatycznie zwrot pieniędzy jeśli anulowałes minimum 8 godzin przed lotem.'
            },
            {
              title: 'Czy dysponujecie fotelikami dla dzieci?',
              paragraph: 'Tak. Podczas rezerwacji przejazdu, w aplikacji możesz wybrać jaki fotelik potrzebujesz. Natomiast jeśli dokonujesz rezerwacji telefonicznie, nasz pracownik dopasuje odpowiednią dla Ciebie opcję.'
            }
          ]
        ,
        paymentQuestions:
          [
            {
              title: 'Czy mogę płacić kartą?',
              paragraph: 'Tak. Zarówno w aplikacji, jak i bezpośrednio u kierowcy w busie możesz płacić kartami Visa oraz Mastercard.'
            },
            {
              title: 'Czy mogą płacić w gotówce?',
              paragraph: 'Tak. Przyjmujemy płatność w gotówce w koronach norweskich (NOK).'
            },
            {
              title: 'Czy pieniądze zostaną mi zwrócone?',
              paragraph: 'Jeśli anulujesz podróż do 8 godz. przed lotem, zwrócimy Ci poniesione koszty. Pieniądze wrócą na Twoje konto do 10 dni roboczych.'
            },
          ],
        accountQuestions:
          [
            {
              title: 'Jak utworzyć konto?',
              paragraph: 'Aby utworzyć konto, wejdź w zakładkę "rejestracja" na naszej stronie internetowej. Będziesz jedynie musiał zweryfikowac swój numer telefonu.'
            },
            {
              title: 'Czy mogę wprowadzać zmiany w swojej rezerwacji?',
              paragraph: 'Możesz wprowadzać zmiany w swojej rezerwacji do godziny 18:00 dzień przed lotem. Możesz edytować liczbę pasażerów, adres oraz dodawać/anulować/zmieniać foteliki dla dzieci. '
            },
            {
              title: 'Jak anulować rezerwację?',
              paragraph: 'Aby anulować rezerwację, zaloguj się na swoje konto i w panelu głównym kliknij "anuluj rezerwację".  <br /><br />Jeśli jeszcze nie masz konta w naszej aplikacji, rezerwację możesz anulować telefonicznie pod <a href="tel:+4796701103">+47 96 70 11 03</a> a jeden z naszych przedstawicieli anuluje rezerwację.'
            },
            {
              title: 'Zapomniałem hasła.',
              paragraph: 'Możesz stworzyć nowe hasło używając opcji "Zapomniałem hasła". Smsem otrzymasz od nas kod, po wpisaniu którego będziesz mógł utworzyć nowe hasło.'
            },
            {
              title: 'Mam nowy nr telefonu.',
              paragraph: 'Numer telefonu możesz zmienić po zalogowaniu się w aplikacji w zakładce "Moje konto.'
            },
          ]
      },
      contact: {
        title: "Kontakt",
        description: "Zwróć się do nas, a chętnie odpowiemy na wszelkie Twoje pytania.",
        desc: {
          title: "W kontakcie!",
          content: "Skontaktuj się z nami",
          paragraphs: {
            first: {
              title: "Nasze biuro pracuje codziennie",
              desc: "od 08:00 do 21:00"
            },
            second: {
              title: "Co możemy dla Ciebie zrobić?",
              //              desc: "We’re here to help"
            },
            third: {
              title: "Dokonaj rezerwacji",
              desc: "Możesz dokonać rezerwacji na transfer lotniskowy używając naszej apliacji lub kontaktując się z nami telefonicznie."
            },
            fourth: {
              title: "Wsparcie klienta",
              desc: "Czy masz jakiekolwiek pytania? Skonaktuj się z nami, z przyjemnością rozwiejmy wszelkie wątpliwości!"
            }
          }
        },
        form: {
          title: "Skontaktuj się z nami",
          inputs: {
            name: {
              label: "Imię i nazwisko / firma",
              placeholder: "Twoje imię"
            },
            email: {
              label: "email",
              placeholder: "Twój email"
            },
            message: {
              label: "Twoja wiadomość",
              placeholder: "Co chcesz nam powiedzieć?"
            },
            sendButton: "Wyślij",
            sendingButton: 'Wysyła...'
          }
        }
      },
      pricing: {
        title: "Cennik przejazdów",
        desc: "Skorzystaj z najlepszych cen przejazdu do i z lotniska Oslo Torp",
        adults: "dorośli",
        kids: "dzieci*",
        info: "*Możesz skorzystać z tańszych biletów dla dzieci do 12 roku życia.",
        infoPromotion: "**Promocja trwa od 17.08.2023 do 15.01.2024",
        doorToDoor: {
          titleGardermoen: "Transfer pod adres Oslo Gardermoen",
          title: "Transfer pod adres Oslo Sandefjord Torp",
          column: "pod adres",
        },
        busStop: {
          title: "Transfer z przystanku Oslo Sandefjord Torp",
          column: "przystanek",
        }
      },
      termsAndConditions: {
        title: "Regulamin",
        desc: "Zasady i przepisy regulujące jazdę z PKS Oslo",
        general: {
          title: "Główne zasady",
          list: [
            { content: "Operatorem, którym jest transfer z lotniska, jest Flyo AS z siedzibą w Bekkenstenveien 53B, Oslo, zwanym dalej „przewoźnikiem”." },
            { content: "Niniejsze warunki określają zasady sprzedaży biletów, transportu pasażerów i bagażu przewożonych przez Flyo AS." },
            { content: "Dokumentem upoważniającym do transferu jest „potwierdzenie SMS”, „potwierdzenie e-mailem” lub „pokwitowanie z kasy fiskalnej”, zwane dalej „biletem”." },
            { content: "Dokonanie rezerwacji w Flyo AS oznacza akceptację „Warunków”" }
          ]
        },
        booking: {
          title: "Warunki rezerwacji",
          list: [
            { content: "Rezerwacje na transfer lotniskowy można dokonać za pomocą aplikacji rezerwacyjnej lub dzwoniąc na linię obsługi klienta. Rezerwacja jest potwierdzana po otrzymaniu e-maila z potwierdzeniem lub SMSem." },
            { content: "Nie ma potrzeby drukowania wiadomości e-mail z potwierdzeniem. Kierowca zostanie poinformowany o wszystkich pasażerach i będzie potrzebował imię i / lub numeru telefonu." },
            { content: "Dane klientów nie są udostępniane ani sprzedawane osobom trzecim, a wszystkie dane klientów są przechowywane zgodnie z prawem norweskim." },
            { content: "Flyo AS odpowiada za wykonanie i jakość sprzedawanej usługi." },
            {
              content: "Flyo AS odpowiada za:",
              list: [
                { content: "transakcje kartą kredytową dokonywane za pośrednictwem tej strony internetowej." },
                { content: "informowanie, kiedy kierowca będzie w uzgodnionym miejscu odbioru, dzień przed odlotem." },
                { content: "informowanie o wszelkich istotnych zmianach w rezerwacji." },
              ]
            },
            { content: "Rezerwacja staje się wiążąca, gdy zostanie potwierdzona telefonicznie lub pisemnie przez Flyo AS. Rezerwacje online stają się wiążące po otrzymaniu wiadomości e-mail z potwierdzeniem." },
            { content: "Aby anulować lub edytować rezerwację, skontaktuj się z PKS Oslo pocztą elektroniczną: <a href='mailto:info@pksoslo.com'>info@pksoslo.com</a>. Można to również zrobić ręcznie za pomocą naszej aplikacji." },
            { content: "Anulowanie rezerwacji może nastąpić do 8 godzin przed planowanym lotem z pełnym zwrotem kosztów. Zwrot nie zostanie dokonany, jeśli odwołanie nastąpi mniej niż 8 godzin przed planowanym lotem." },
            { content: "Zmiana rezerwacji na inną datę jest bezpłatna, jeśli została dokonana więcej niż 8 godzin przed planowanym odlotem." },
            { content: "Edytowanie pasażerów, miejsca odbioru i fotelików dziecięcych jest możliwe do godziny 18.00 jeden dzień przed lotem i jest bezpłatne." },
            { content: "Ceny są w koronach norweskich (NOK). Wszystkie ceny zawierają podatek VAT." },
          ]
        },
        carrier: {
          title: "Przewoźnik",
          list: [
            { content: "Przewoźnik nie ponosi odpowiedzialności za opóźnienia i ich dalsze konsekwencje spowodowane czynnikami administracyjnymi (np. Kontrole policyjne) lub innymi czynnikami niezależnymi od Przewoźnika (np. Problemy techniczne, warunki pogodowe, korki)." },
            { content: "Przewoźnik będzie dążył do przewozu pasażera i bagażu w rozsądnym czasie zgodnie z planem podróży, ale z przyczyn od niego niezależnych nie może tego zagwarantować." },
            { content: "Przewoźnik zastrzega sobie prawo do korzystania z usług połączeń w trakcie podróży ze względów logistycznych lub dla bezpieczeństwa pasażerów." },
            { content: "Pasażerowie, którzy nie są w stanie podróżować z winy Przewoźnika, mają prawo do kwoty zwrotu odpowiadającej niewykorzystanemu biletowi." },
            { content: "Rezerwacje odbywają się poprzez złożenie zamówienia przez telefon lub poprzez aplikacji rezerwacyjnej na <a href='http://www.pksoslo.com'>www.pksoslo.com</a>. Rezerwacje są potwierdzane w momencie otrzymania e-maila z potwierdzeniem." },
            {
              content: "Przewoźnik ma prawo nie dopuścić pasażerów w autobusie lub odmówić dalszego przewozu bez zwrotu kosztów poniesionych przez Pasażera, gdy pasażer:",
              list: [
                { content: "nie jest zgodny z zasadami tych przepisów," },
                { content: "jest pod wpływem alkoholu lub narkotyków" },
                {
                  content: "jest w stanie lub zachowuje się w sposób, który może niekorzystnie wpłynąć na bezpieczeństwo lub komfort innych pasażerów. <br>Skutki prawne tych sytuacji ponosi Pasażer."
                }
              ]
            },
            { content: "Nie wolno spożywać napojów alkoholowych, narkotyków ani papierosow." },
            { content: "Dozwolone jest przewożenie niektórych zwierząt domowych po uprzednim poinformowaniu Przewoźnika. Transportowane zwierzę musi być odpowiednio zabezpieczone, znajdować się w klatce i być umieszczone na siedzeniu obok pasażera. Transport zwierząt musi odbywać się bez przeszkadzania innym pasażerom podczas podróży." },
            { content: "Koszt transportu, podatków, opłat i opłat za usługi Flyo AS nie podlega zwrotowi w przypadku, gdy pasażer nie pojawi się w uzgodnionym miejscu spotkania." },
          ]
        },
        passengers: {
          title: "Pasażerowie",
          list: [
            { content: "Pasażerowie powinni przybyć do wyznaczonego miejsca o wyznaczonej godzinie. Przewoźnik nie ma obowiązku czekać na pasażerów niespełniających tego warunku." },
            { content: "Pasażerowie są zobowiązani do przestrzegania przepisów policyjnych podczas podróży." },
            { content: "Pasażerowie są odpowiedzialni za wszelkie szkody wyrządzone Przewoźnikowi (w szczególności za szkody w autobusie) i innym pasażerom na ogólnych zasadach określonych w Kodeksie cywilnym." },
            { content: "Pasażerowie muszą korzystać z pasów bezpieczeństwa podczas podróży." },
            { content: "Dzieci poniżej 12 roku życia, które nie przewyższają 150 cm wysokości, przewożone w autobusie muszą korzystać z fotelików lub innego sprzętu do przewożenia dzieci, odpowiadającego wadze i wzrostowi dziecka. Dziecko powinno pozostać przez całą podróż w zabezpieczonym fotelu ochronnym. Pasażer musi powiadomić Przewoźnika, które foteliki ochronne należy zabrać przy tworzeniu rezerwacji." },
            { content: "Przewoźnik nie ponosi odpowiedzialności za nieletnich podróżujących bez opiekuna." },
            { content: "Przewoźnik nie ponosi odpowiedzialności za przedmioty pozostawione w autobusie." }
          ]
        }
      },
      privacyPolicy: {
        title: "Polityka prywatności",
        introduction: {
          title: "Wstęp",
          list: [
            { content: "<strong>Flyo AS</strong> („Przewoźnik”) dokłada wszelkich starań, aby nam zaufać i przetwarzać dane osobowe. Dlatego w niniejszym oświadczeniu o ochronie prywatności wyjaśniamy, dlaczego zbieramy informacje o Tobie, w jaki sposób korzystamy z tych informacji i jak uwzględniamy Twoją prywatność." },
            { content: 'Dane osobowe to informacje i oceny, które można powiązać z dającą się zidentyfikować osobą. Mogą to być na przykład nazwiska i dane kontaktowe, historia transakcji lub informacje o zainteresowaniach.' },
            { content: "Wykorzystanie danych osobowych musi być zgodne z ustawą o danych osobowych. My, jako kontroler, zapewniamy, że będziemy wykorzystywać Twoje dane osobowe zgodnie z prawem." }
          ]
        },
        whatPersonalInformation: {
          title: "Jakie dane osobowe mamy o Tobie?",
          list: [
            { content: "W zależności od tego, jakie informacje nam przekazujesz, w jaki sposób korzystasz z naszych usług i jakie uprawnienia nam przekazujesz, mamy następujące informacje o Tobie:" },
            { content: '<strong>Informacje o Tobie:</strong> Informacje podawane podczas tworzenia konta użytkownika lub zamówienia biletów, takie jak imię i nazwisko, adres, numer telefonu i adres e-mail.' },
            { content: "<strong>Informacje o zakupie:</strong> informacje, które otrzymujemy, gdy kupujesz u nas bilety, takie jak zakup, numer karty i metoda płatności (np. Visa). Jeśli masz konto użytkownika u nas, otrzymasz przegląd swoich poprzednich przejazdów na koncie użytkownika." },
            { content: "<strong>Komunikacja:</strong> Informacje, które przekazujesz nam, gdy kontaktujesz się z naszym centrum obsługi klienta, takie jak wiadomości e-mail wysyłane między nami." },
            { content: "<strong>Informacje o użytkowaniu strony internetowej:</strong> Informacje, które otrzymujemy podczas korzystania z naszej strony internetowej i aplikacji, takie jak rodzaj posiadanego urządzenia (np. Telefon komórkowy lub komputer), adres IP, odwiedzane strony i funkcje, których tam używasz." },
            { content: "<strong>Informacje o profilowaniu:</strong> informacje i założenia, które automatycznie tworzymy w oparciu o inne informacje (o których mowa powyżej) o Tobie, takie jak Twoje preferencje i zainteresowania oraz do jakich grup demograficznych należysz, chyba że temu zaprzeczasz." },
          ]
        },
        whatWeUsePersonalInformationFor: {
          title: "Do czego wykorzystujemy dane osobowe",
          list: [
            { content: "Wykorzystujemy Twoje dane osobowe do następujących celów:" },
            { content: '<strong>Witryna i aplikacja:</strong> Używamy tych informacji, aby dostosować naszą stronę internetową i aplikację do używanego sprzętu technicznego.' },
            { content: "<strong>Wykonaj rezerwację biletów:</strong> Używamy tych informacji do ukończenia zakupu biletu, w tym: aby wysłać Ci bilety, otrzymać płatność i zapisać historię zakupów." },
            { content: "<strong>Tworzenie konta użytkownika:</strong> Używamy informacji, jeśli tworzysz konto, musisz podać nazwę użytkownika i hasło, aby przechowywać informacje kontaktowe i informacje o płatnościach, a także aby wyświetlić historię zakupów." },
            { content: "<strong>Obsługa klienta:</strong> Przechowujemy informacje, które przekazujesz i otrzymujesz, jeśli skontaktujesz się z nami w celu świadczenia usług i zarządzania relacjami z klientami." },
            { content: "<strong>Statystyki:</strong> Tworzymy statystyki i mapujemy trendy rynkowe w celu ulepszenia i dalszego rozwoju naszych produktów i usług. W miarę możliwości robimy to za pomocą anonimowych informacji." },
            { content: "<strong>Marketing:</strong> Używamy Twoich danych kontaktowych (np. Numeru telefonu i adresu e-mail) do wysyłania Ci rekomendacji i informacji o naszych usługach. Możemy wykorzystywać informacje profilowania, aby zalecenia i informacje były dla Ciebie najbardziej istotne, chyba że temu zaprzeczasz. Jeśli chcesz, prześlemy Ci także zalecenia i informacje o występach naszych partnerów." },
            { content: "Podstawą prawną dla celów <strong>1</strong>, <strong>4</strong> i <strong>5</strong> jest nasz uzasadniony interes w dostarczaniu, rozwijaniu i marketingu naszych usług." },
            { content: "Podstawą prawną dla celów <strong>2</strong>, <strong>3</strong> i <strong>4</strong> jest wypełnienie naszej umowy z tobą." },
            { content: "Podstawą prawną celu <strong>5</strong> może być również twoja zgoda, jeśli nam to dałeś. Może być konieczne wysłanie Ci marketingu, jeśli nie masz już konta użytkownika, lub jeśli wysyłamy Ci marketing dotyczący wyników naszych partnerów." },
          ]
        },
        whoWeSharePersonalInformationWith: {
          title: "Komu udostępniamy dane osobowe",
          list: [
            { content: "Udostępniamy dane osobowe firmom, które świadczą nam usługi techniczne i administracyjne, takie jak dostawcy IT. Mamy z nimi umowy, aby zapewnić prywatność." },
            { content: "Możemy ujawniać informacje w indywidualnych przypadkach, na przykład organom publicznym, w przypadku podejrzenia popełnienia przestępstwa." },
            { content: "Jeśli wyrazisz na to zgodę, możemy udostępnić Twoje dane osobowe naszym partnerom, zgodnie z Twoją zgodą. Używamy dostawców IT na terenie Polski." },
            { content: "Możemy także udostępniać anonimowe informacje partnerom, między innymi. analiza rynku i rozwój usług." },
          ]
        },
        howLongWeStorePersonalInformation: {
          title: "Jak długo przechowujemy dane osobowe",
          list: [
            { content: "Przechowujemy informacje o Tobie tylko tak długo, jak jest to konieczne do osiągnięcia celu, dla którego zostały uzyskane, lub jeśli jesteśmy zobowiązani do przechowywania informacji. Informacje zostaną usunięte lub zanonimizowane, gdy nie będą już potrzebne do tego celu. Poniżej znajduje się przegląd tego, jak długo przechowujemy Twoje informacje:" },
            { content: "<strong>Informacje o Tobie:</strong> Jeśli masz konto użytkownika u nas, możesz skontaktować się z nami, a my usuniemy informacje o Tobie." },
            { content: "<strong>Informacje o zakupie:</strong> jeśli masz konto użytkownika u nas, będziemy przechowywać historię przejazdów. Przechowujemy transakcje i informacje o płatnościach przez 5 lat zgodnie z ustawą o rachunkowości." },
            { content: "<strong>Informacje o korzystaniu z witryny:</strong> przechowujemy informacje o korzystaniu z naszej strony internetowej przez okres do 6 miesięcy." },
            { content: "<strong>Informacje o partnerach:</strong> Przechowujemy wszelkie informacje dotyczące partnerów, o ile masz aktywne konto użytkownika u nas lub tak długo, jak wyrażasz na to zgodę. Usuniemy informacje, jeśli anulujesz swoje konto użytkownika." },
            { content: "<strong>Komunikacja:</strong> Przechowujemy komunikację z naszymi klientami przez trzy lata, chyba że musimy przechowywać je dłużej, np. w związku ze skargami lub roszczeniami." },
            { content: "<strong>Informacje o profilowaniu:</strong> jeśli masz konto użytkownika u nas, usuniemy te informacje po zakończeniu konta użytkownika lub konta użytkownika. Usuniemy informacje wcześniej, jeśli sprzeciwiasz się profilowaniu." },
          ]
        },
        yourRights: {
          title: "Twoje prawa",
          list: [
            { content: "Masz prawo poprosić nas o:" },
            {
              list: [
                { content: "Dodatkowe informacje o tym, jak przetwarzamy Twoje dane osobowe." },
                { content: "Kopię danych osobowych o Tobie." },
                { content: "Zaktualizowanie swoich danych osobowych." },
                { content: "Usuń informacje, które nie mają już podstaw do przechowywania." },
                { content: "Ogranicz lub zatrzymaj przetwarzanie swoich informacji." },
                { content: "Zatrzymanie automatycznym indywidualnym decyzjom, w tym profilowaniu." },
                { content: "Informacje, które nam przekazałeś w ustrukturyzowanym, powszechnie używanym i czytelnym dla komputera formacie lub, jeśli jest to technicznie możliwe, poproś nas o przeniesienie ich do innej firmy." },
                { content: "Wycofanie wszelkie udzielone nam zgody." },
              ]
            },
            { content: "Należy pamiętać, że istnieją ograniczenia tych praw. Skontaktuj się z nami, aby uzyskać więcej informacji na ten temat." },
            { content: "Jeśli uważasz, że przetwarzamy dane osobowe z naruszeniem Ustawy o danych osobowych, masz prawo odwołania się do Inspektoratu Danych. Zanim to zrobisz, chcielibyśmy, abyś skontaktował się z nami, abyśmy mogli odpowiedzieć na Twoje pytania lub rozwiązać wszelkie nieporozumienia." },
          ]
        },
        cookies: {
          title: "Plików cookie",
          list: [
            { content: "Używamy plików cookie na naszej stronie, aby zapewnić funkcjonalność strony, przeanalizować ruch w sieci i zobaczyć, które witryny w naszej witrynie odwiedziłeś." },
          ]
        },
        changesToThePrivacyStatement: {
          title: "Zmiany w oświadczeniu o ochronie prywatności",
          list: [
            { content: "Możemy okresowo aktualizować oświadczenie o ochronie prywatności. Zostaniesz powiadomiony o istotnych zmianach. Zawsze znajdziesz najnowszą wersję naszego oświadczenia o ochronie prywatności na stronie / aplikacji." },
          ]
        },
        contactInformation: {
          title: "Informacje kontaktowe",
          list: [
            { content: "Jeśli chcesz się z nami skontaktować, możesz użyć następujących informacji kontaktowych:" },
          ],
          address: [
            { content: 'Numer telefonu: <a href="tel:4796701103" itemProp="telephone">+47 96 70 11 03</a>' },
            { content: 'Adres e-mail: <a href="mailto:info@pksoslo.com" itemProp="email">info@pksoslo.com</a>' },
            { content: 'Adres: <span itemProp="streetAddress">Bekkenstenveien 53B</span>,<span itemProp="postalCode">0976</span> <span itemProp="addressLocality">Oslo</span>' },
          ]
        },
      },
    },
    notifications: {
      default: {
        success: "Sukces",
      },
      contact: {
        error: 'Błąd',
        cannotBeSent: 'Twój e-mail nie może zostać wysłany. Spróbuj ponownie.',
        success: 'Wiadomość wysłana!',
        successMessage: 'Odpowiemy wkrótce.'
      },
      reviews: {
        error: 'Błąd',
        noComment: 'Wprowadź komentarz',
        success: 'Twoja opinia została wysłana. Dziękujemy!'
      },
      settings: {
        success: "Zapisano",
        error: "Ups! Nie można zapisać. Odśwież stronę i spróbuj ponownie."
      },
      invoices: {
        successMessage: "Dane zostały zapisane.",
        errorTitle: "Błąd"
      },
      cards: {
        success: "Dodano kartę.",
        error: "Błąd"
      },
      cardItems: {
        success: "Karta została usunięta.",
        error: "Błąd",
        errorMessage: "Wystąpił błąd podczas usuwania karty."
      },
      addressItem: {
        success: "Adres został usunięty.",
        error: "Błąd",
        errorMessage: "Wystąpił błąd podczas usuwania adresu."
      },
      addressComponent: {
        noResults: "No results",
        warning: {
          title: "Uwaga!",
          addressInvalid: "Adres nie jest poprawny.",
          addressInDatabase: "Adres jest już zapisany."
        }
      },
      facebook: {
        error: "Błąd"
      },
      google: {
        error: "Błąd"
      },
      loginPage: {
        error: "Błąd"
      },
      loginForm: {
        success: "Zostałeś zalogowany.",
        error: "Błąd"
      },
      bookingStep4: {
        error: "Błąd"
      },
      phoneSmsVerification: {
        success: "Numer telefonu został zmieniony.",
        error: "Błąd",
        errorMessage: "Podaj cały kod."
      },
      phoneNumberVerification: {
        success: "Konto zostało utworzone i zostałeś zalogowany.",
        error: "Błąd",
        invalidMessage: "Podaj cały kod."
      },
      profileResetPassword: {
        success: "Hasło zostało zmienione.",
        error: "Błąd"
      },
      mapPlaces: {
        success: {
          addressInDatabase: "Adres jest już zapisany.",
        },
        warning:
        {
          title: "Uwaga!",
          addressSaved: "Adres został zapisany."
        },
        error: "Błąd",
        errorMessage: "Wystąpił błąd podczas zapisywania adresu",
      },
      reservationEdit: {
        error: "Błąd",
        errorSubmit: "Błąd!",
        warning: {
          title: "Uwaga!",
          message: "Nie zmieniono parametrów rezerwacji."
        }
      },
      suplementSummary: {
        success: "Zmiany w rezerwacji zostały zapisane.",
        error: "Błąd"
      },
      notificationButtons: {
        cancelSuccess: "Rezerwacja została anulowana.",
        error: "Błąd",
      }
    },
    supplementSummary: {
      paySupl: "Zapłać"
    },
    reservationEdit: {
      address: "Adres",
      editAddress: "Edytuj adres",
      passengers: "Pasażerowie",
      adults: "dorośli",
      kids: "dzieci",
      students: "studenci",
      editPassengers: "Edytuj pasażerów",
      oldPrice: "Stara cena",
      changePrice: "Zmiana w cenie",
      newPrice: "Nowa cena",
      payWithCard: "Wybrałeś płatność kartą",
      payDriver: "Wybrałeś płatność u kierowcy. Nie musisz płacić teraz.",
      changeDetails: "Zmień szczegóły rezerwacji",
      changeNothing: "Nie chcę niczego zmieniać",
      reservationEditPassengers: {
        title: "Pasażerowie",
        desc: "Zmiana planów? Zaktualizuj ilość pasażerów",
        adults: "dorośli",
        kids: "dzieci",
        students: "studenci",
        kidsSafetyTitle: "Foteliki bezpieczeństwa",
        tripMessage: "Podróżujesz z dziećmi.",
        carSeatsMessage: "Jakich fotelików potrzebujesz?",
      }
    },
    form: {
      inputPhoneNumber: "numer telefonu",
      changePhoneNumber: "Zmień numer telefonu",
      changePassword: "Zmień hasło",
      changePhoneAndPassword: "Edytuj numer telefonu i hasło",
      changePhoneDescriptionFirst: "Nowy numer teletonu musi być jeszcze raz zweryfikowany.",
      changePhoneDescriptionSecond: "Wyślemy Ci kod weryfikacyjny smsem.",
      changePhoneSuccessMessage: "Pomyślnie zmieniono numer telefonu."
    },
    errors: {
      passengerCount: "Uzupełnij poprawnie ilość pasażerów.",
      childrenSeats: 'Wybierz fotelik dla dzieci.',
      card: {
        cardNumber: 'Niepoprawny numer karty.',
        cardCvc: 'Niepoprawny CVC.',
        date: 'Niepoprawna data.',
        datePast: 'Data nie może być przeszła.'
      },
      contact: {
        email: 'E-mail jest nie prawidłowy',
        name: 'Imię jest nieprawidłowe',
        message: 'Wiadomość jest nieprawidłowa',
      },
      auth: {
        loginPage: {
          passwordBlank: 'podaj hasło'
        },
        loginForm: {
          passwordBlank: 'podaj hasło'
        },
        newPassswordAndCode: {
          codeFull: "Proszę wpisać cały kod",
          codeEmpty: 'Proszę wpisać kod'
        },
        emailForm: {
          emailEmpty: "Adres email jest wymagany",
          emailInvalid: "Niepoprawny adres email",
          requestError: "Wystąpił błąd. Spróbuj ponownie."
        },
        customerBasicValidation: {
          nameToShort: "Minimum 3 znaki",
          nameToLong: "Nazwa jest zbyt długa",
          emailInvalid: "Adres email jest niepoprawny",
          passwordToShort5chars: "Minimum 5 znaków",
          passwordToLong: "Hasło jest za długie.",
        },
        customerAddressValidation: {
          latEmpty: "Lat cannot be empty",
          lngEmpty: "Lng cannot be empty",
          streetEmpty: "Pole 'adres' nie może pozostać puste",
          postCodeEmpty: 'Pole "kod pocztowy" nie może być puste',
          typeEmpty: "Type cannot be empty"
        },
        customerPhoneValidation: {
          exactlyLength: "Numer telefonu powinien mieć %size% cyfr",
          minNumbersPre: "Minimum",
          minNumbersPost: "cyfr",
          phoneToLong: "Numer telefonu jest zbyt długi",
          countryCodeEmpty: "Brak numeru kierunkowego"
        },
        registrationFormStep1: {
          emailBusy: "Adres email jest zajęty"
        }
      }
    },
    auth: {
      loginPage: {
        title: "Cześć! Miło znów Cię widzieć.",
        subtitle: "Kontynuuj z",
        authSeparator: "lub",
        passwordLabel: "hasło",
        forgotPassword: "Zapomniałeś hasła?",
        logIn: "Zaloguj się",
        accountInfo: "Nie masz jeszcze konta?",
        createAccount: "Załóż konto",
      },
      newPassswordAndCode: {
        title: 'Zmień hasło',
        codeTitle: 'Wysłaliśmy Ci 4-cyfrowy kod weryfikacyjny.',
        codeSentTo: 'na adres',
        newPasswordLabel: "nowe hasło",
        backToEmail: "Wróć do adresu email",
        changePasswordButton: "Zmień hasło"
      },
      emailForm: {
        title: "Zmień hasło",
        description: "Wpisz swój adres email, wyślemy na niego kod weryfikacyjny.",
        emailLabel: "Adres email",
        remember: "Pamiętam! ",
        goBack: "Wróć",
        resetPasswordButton: "Zmień hasło",
        successMessage: "Pomyślnie zmieniono hasło"
      },
      registrationForm: {
        title: 'Kontynuuj z',
        or: 'lub',
        signUpEmail: 'Zaloguj się przez email',
        haveAccount: 'Masz już konto?',
        logIn: 'Zaloguj się'
      },
      registrationFormStep1: {
        header: 'Miło cię poznać',
        labels: {
          fullname: "Imię i nazwisko",
          email: "email",
          password: "hasło"
        },
        terms: {
          first: "Kontynuując akceptujesz ",
          second: "Regulamin",
          and: "i",
          third: "Politykę prywatności"
        },
        haveAccount: 'Masz juz konto?',
        logIn: 'Zaloguj się'
      },
      registrationFormStep2: {
        linkTitle: "Edytuj dane kontaktowe",
        title: "Prawie gotowe",
        description: "Prosimy, upewnij się, ze numer telefonu jest poprawny.",
        descriptionSms: "Wyślemy Ci kod weryfikacyjny smsem"
      },
      registrationFormStep3: {
        headerLinkTitle: "Edytuj email",
        headerTitle: "Wprowadź kod weryfikacyjny",
        headerDescription: "Wysłaliśmy Ci 4-cyfrowy kod weryfikacyjny na %email%",
        wrongQuestion: "Zły email?",
        change: "Zmień go",
        changeTitle: "Zmień email",
        receiveCodeQuestion: "Nie otrzymałeś kodu?",
        sendAgain: "Wyślij ponownie",
        separator: "albo",
        skipTitle: "pomiń",
        skip: " kontynuuj bez zakładania konta",
        done: "Gotowe"
      }
    },
    userData: {
      backToAddress: "Wróć do adresu",
      backToPersonalData: "Wróć do danych osobowych",
      personalData: "Dane kontaktowe",
      loginForm: {
        accountInfo: "Nie masz konta?",
        register: "Zarejestruj się",
        passwordLabel: "hasło"
      },
      registerForm: {
        accountInfo: "Masz już konto?",
        logIn: " Zaloguj się",
        labels: {
          fullname: "Imię i nazwisko",
          email: "email",
          password: "hasło"
        },
        createAccount: "Chcesz utworzyć konto?",
      },
      changePhoneForm: {
        sendCodeInfo: "Wysłaliśmy Ci 4-cyfrowy kod weryfikacyjny na %phone_label% %phone_number%",
        backToPhone: "Wróć do nr telefonu",
        done: "Gotowe"
      }
    },
    addressItem: {
      deleteTitle: 'Usuń adres',
      deleteQuestion: 'Jesteś pewny, że chcesz usunąć ten adres?',
      confirmButton: 'Tak',
      rejectButton: 'Nie, zachowaj',
      deletePlaceTitle: 'Usuń miejsce'
    },
    account: {
      editProfileTitle: 'Edytuj profil',
      menu: {
        myTrips: 'Moje przejazdy',
        cards: 'Moje karty',
        places: 'Moje miejsca',
        invoices: 'Faktury',
        settings: 'Ustawienia'
      },
      card: {
        deleteCard: 'Usuń kartę',
        deleteCardMessage: 'Czy na pewno chcesz usunąć tę kartę?',
        title: 'Moje karty',
        stripeTitle: 'Bezpieczne płatności przez Stripe',
        addNewCardTitle: 'Dodaj nową kartę',
        cardNumberPlaceholder: 'Numer karty',
        cardDatePlaceholder: 'MM/RR',
        cardCvcPlaceholder: 'CVC',
        addCardButton: 'Dodaj kartę',

        removeBtnConfirm: 'Tak',
        removeBtnCancel: 'Nie, zachowaj',
        chooseCard: 'Wybierz kartę',
        emptyCardsList: 'Nie masz zapisanych żadnych kart.',
        addNewCardButton: 'Dodaj nową kartę',

        addNewOne: 'dodaj nową',
        saveCard: 'Zapisz kartę',
        invoiceInfo: 'Informacje do faktury',
      },
      places: {
        title: 'Moje miejsca',
        myPlaces: 'Miejsca',
        list: {
          favPlacesEmpty: 'Nie masz żadnych zachowanych miejsc.',
          addNewAddress: 'Dodaj nowy adres'
        }
      },
      invoices: {
        invoiceInfo: 'Informacje do faktury',
        invoiceSave: "Zapisz",
        form: {
          companyNameLabel: 'Nazwa firmy',
          addressLabel: 'Adres',
          taxNumberLabel: 'NIP',
          checkboxInfo: 'Faktura dla każdej rezerwacji',
        },
      },
      settings: {
        title: 'Ustawienia',
        notifications: 'Powiadomienia',
        language: 'Język',
        logout: 'Wyloguj',
        langs: {
          en: 'English',
          no: 'Norsk',
          pl: 'Polski',
          ru: 'Русский'
        }
      }
    },
    login: {
      title: 'Panel logowania',
      footer: 'footer'
    },
    sessions: {
      login: {
        title: 'Formularz logowania',
        email: 'Podaj email',
        password: 'Podaj hasło'
      }
    },
    dashboard: {
      myTrips: "Moje przejazdy",
      filterByDate: 'Wybierz datę',
      getInvoice: 'Pobierz fakturę',
      notFoundTrips: "Nie znaleziono rezerwacji",
      upcoming: "Nadchodzące przejazdy",
      payToDriver: 'Zapłać u kierowcy',
      payWithCard: 'Zapłacone kartą',
      notificationButtons: {
        cancelBookingConfirm: "Tak, anuluj rezerwację",
        cancelBookingText: "Nie, zachowaj",
        refundInfo: "Jeśli płaciłeś kartą, pieniądze wrócą na Twoje konto do 10 dni roboczych",
        infoWithoutRefundNotification: "Jeśli płaciłeś kartą, pieniądze wrócą na Twoje konto do 10 dni roboczych",
        editButton: "Edytuj",
        cancel: "Usuń",
        booking: "Rezerwacje",
        cancelBooking: {
          title: "Jesteś pewny, że chcesz anulować rezerwację?",
          message: "%on% z %from% do %to%"
        },
        closeTitle: "Zamknij"
      },
      slider: {
        title: "Jak przebiegła Twoja podróż z %driverName%?",
        desc: "%date% z %from% do %to%",
        content: "Jak przebiegła Twoja podróż? Będziemy wdzięczni za opinie!",
        addReview: "Dodaj recenzję",
        closeReview: "Zamknij recenzję",
        textAreaPlaceholder: "Chcielibyśmy wiedzieć wiecej"
      },
      summary: {
        newPrice: "Nowa cena",
        changePrice: "Zmiana w cenie",
        paySupl: "Zapłać",
        refund: "Do zwrotu",
        oldPrice: "Stara cena",
        changesSaved: "Twoje zmiany zostały zapisane",
        payDriver: "Wybrałeś płatność u kierowcy. W busie możesz zapłacić kartą lub gotówką (NOK).",
        buttonText: "OK"
      }
    },
    invoiceCheckbox: {
      company: "Płaci firma?",
      addInvoice: "Dodaj informacje do faktury",
      canceledInfo: "Twoja prośba o faktutę zostanie anulowana.",
      fillTheForm: {
        first: "Proszę",
        last: " wypełnij cały formularz"
      },
      issueInvoice: "Wystaw fakturę dla ",
      changeInfo: "Potrzebujesz zmienić informacje do faktury?"
    },
    flyOut: 'Wylot',
    flyBack: 'Przylot',
    common: {
      success: "Zapisano",
      error: "Bląd",
      terms: "Regulamin",
      privacyPolicy: "Polityka prywatności",
      logIn: "Zaloguj się",
      signUp: "Załóż konto",
      bookNow: "Zarezerwuj teraz",
      nothingInfo: "Nic tu nie ma",
      nothingMessage: "Twoje rezerwację będą dostępne tutaj.",
      previous: "Poprzedni",
      loggedInError: "Musisz być zalogowany.",
      loggedInMessage: "Witaj ponownie!",
      skipToLogin: "Zaloguj się",
      somethingWrong: "Coś poszło nie tak",
      optional: 'opcjonalne',
      adults: 'dorośli',
      kids: 'dzieci',
      students: 'studenci',
      under: 'do',
      step: 'krok',
      next: 'Dalej',
      price: 'cena',
      currency: 'nok',
      backToBooking: 'Wróć do rezerwacji',
      backToLogin: 'Wróć do logowania',
      backToProfile: 'Wróć do swojego profilu',
      ok: 'Ok',
      signUpWithEmail: 'Zaloguj się przez email',
      close: 'Zamknij',
      show: 'Pokaż',
      hide: 'Ukryj',
      back: 'Wróć',
      save: 'Zapisz',
      inputs: {
        oldPassword: 'stare hasło',
        newPassword: 'nowe hasło'
      },
      contact: {
        phone: "(+47) 96 70 11 03",
        phoneTitle: "Zadzwoń do nas",
        email: "info@pksoslo.com",
        emailTitle: "Wyślij nam email"
      }
    },
    calendar: {
      oneWay: 'W jedną stronę',
      confirm: 'Ok'
    },
    bookingStep1: {
      mobile: {
        selectDate: 'Wybierz datę',
        selectDates: 'Wybierz datę',
        selectAirportLabel: 'Wybierz lotnisko',
        selectAirportTitle: 'Wybierz lotnisko',
      },
      headerChooseAirport: 'Wybierz lotnisko',
      header: 'Zarezerwuj transport',
      whatFlight: 'Dokąd lecisz?',
      chooseAirport: {
        listEmpty: 'Nie znaleziono lotniska, spróbuj ponownie.',
        from: 'Wybierz lotnisko z',
        to: 'Wybierz lotnisko do',
      },
      chooseAirportPlaceholder: 'Wybierz lotnisko',
      chooseAirportFrom: 'Z',
      chooseAirportTo: 'Do',
      chooseSelectDate: 'Wybierz datę',
      chooseSelectDatePlaceholder: 'Wyświetl kalendarz',
      letsGo: 'Jedźmy!',
      errors: {
        date: 'Wybierz datę',
        passengers: 'Wybierz ilość pasażerow',
        place: 'Wybierz lokalizację',
        location_same: 'Lokalizacje nie mogą być takie same',
        two_airports: 'Nie można wybrać dwóch lotnisk',
        two_cities: 'Nie można wybrać dwóch miast'
      }
    },
    kidsSafety: {
      labels: {
        firstAge: '0-15 miesięcy',
        firstWeight: '0-13kg',
        secondAge: '1-4 lat',
        secondWeight: '9-18kg',
        thirdAge: '4-12 lat',
        thirdWeight: '15-36kg',
        fourthAge: '4+ lat',
        fourthWeight: '15-36kg',
      },
      title: 'Foteliki bezpieczeństwa',
      tripWithCount: 'Jedziesz z ',
      tripWithCountSufix: ' dzieci.',
      typeOfSeatsQuestion: 'Jakich fotelików potrzebujesz?',
      safetyList: {
        chooseTitle: 'Musisz wybrać ',
        chooseTitleSufix: ' więcej',
        items: {
          cradle: 'Kołyska',
          seatWithSeatBelts: 'Siedzący z pasami',
          seatWithoutSeatBelts: 'Siedzący bez pasów',
          carSeatPad: 'Podkładka',
          noNeedCarSeat: 'Nie potrzebuję fotelika'
        }
      }
    },
    bookingStep2: {
      chooseFlyOut: 'Wylot',
      chooseFlyBack: 'Przylot',
      editKids: 'Edytuj foteliki',
      errors: {
        flight: {
          departure: 'Musisz wybrać lot',
          return: 'Musisz wybrać lot'
        }
      }
    },
    // map
    bookingStep3: {
      map: {
        backToSelectFlight: 'Wróć do wyboru lotu',
        addAddress: {
          first: 'Dodaj ',
          second: ' inny ',
          third: ' adres powrotny'
        },
        removeReturnAddress: 'Usuń adres powrotny',
        addToFav: "Dodaj do ulubionych"
      },
      address: {
        inputPlaceholder: 'Wpisz adres zamieszkania lub wybierz przystanek autobusowy'
      },
      favButton: 'Dodaj do ulubionych',
      favSpotButton: 'Zapisz jako:',
      spots: {
        home: 'Dom',
        work: 'Praca',
        other: 'Inne'
      },
      summary: {
        from: 'z',
        to: 'do',
        totalPrice: 'Cena końcowa',
        smsInfoFirst: 'Dzień przed odlotem wyślemy Ci smsa',
        smsInfoSecond: 'z godziną przyjazdu kierowcy.',
        tooltip: {
          button: 'Więcej o odbiorze',
          departures: 'Odlot: Otrzymasz od nas smsa dzień przed odlotem około godz. 18:00 z godziną przyjazdu busa pod wskazany adres',
          arrivals: 'Przylot: Nasz kierowca będzie na Ciebie czekał przed terminalem lotniska.',
        }
      },
      errors: {
        postCode: 'Brak kodu pocztowego.',
        street: 'Brak numeru domu.',
        coords: 'Nie znaleziono współrzędnych dla wybranego adresu.',
        addressNotFound: 'Nie znaleziono adresu.',
        connection: 'Zerwane połączenie z serwerem', // general info when something is wrong with connection ...
        addressNotSupported: 'Adres nie jest obsługiwany.',
        selectAddress: 'Proszę, wybierz adres.'
      }
    },
    //summary
    bookingStep4: {
      stepHeader: {
        title: 'Podsumowanie rezerwacji',
        linkTitleAddressSelection: 'Wróć do wyboru adresu',
        linkTitleUserSelection: 'Wróć do sekcji użytkownik'
      },
      summary: {
        title: 'Podsumowanie',
        totalPrice: 'Cena',
        bookNow: 'Zarezerwuj',
        payToDriver: 'Zapłać u kierowcy',
        payUsingCard: 'Zapłać kartą',
        passengerData: 'Dane pasażera:',
        phoneFormat: 'Числовой формат: +XXXXXXXXX'
      },
      address: {
        return: 'Powrót: ',
        departure: 'Odlot: '
      },
      errors: {
        payment: {
          emptyData: 'Brak danych. Uzupełnij proces rezerwacji aby kontynuować',
          selectPaymentMethod: 'Wybierz sposób płatności',
          cardDetails: 'Wprowadź dane karty płatniczej',
          paymentFailed: 'Wystąpił błąd podczas płatności'
        },

        map: {
          addressNotSupported: ' Adres nie jest obsługiwany',
          addressEmpty: 'Nie wybrano adresu',
          addressPostalCode: 'Przepraszamy! Nie jeździmy pod ten kod pocztowy.',
          streetNumber: 'Brak numeru ulicy',
          streetCoords: 'Nie znaleziono współrzędnych dla ulicy',
        }
      }
    },
    bookingStepFinal: {
      title: 'Dziękujemy za podróż z nami',
      info: {
        first: 'Twoja rezerwacja została wysłana',
        second: 'Możesz edytować swoją rezerwację do godziny 18.00 jeden dzień przed wyjazdem.',
        third: 'Jeśli masz pytania, skontaktuj się z nami.'
      },
      confirm: 'Ok'

    },
    homepage: {
      title: 'PROSTY DOJAZD NA LOTNISKO',
      content: `Wybierz lot do lub z lotniska Oslo Sandefjord Torp,
       a nastęonie zarezerwuj bus telefonicznie lub na stronie internetowej.
       Odbierzemy Cię z domu, pracy lub lotniska
       Otrzymasz od nas smsa z godziną przyjazdu busa dzień przed planowanym lotem.
       Będziemy również dzwonić na chwilę przed przyjazdem pod wskazany adres`
    },
    prices: {
      title: 'Ceny transportu lotniskowego',
      content: 'Skorzystaj z najlepszych cen transferu lotnisko do i z lotniska Oslo Torp'
    },
    help: {
      header: 'Pomoc',
      question: 'Masz jakieś pytania odnośnie naszego serwisu?',
      checkLink: 'Sprawdź linki poniżej lub skontakuj się z nami.',
      officeWorks: 'Nasze biuro pracuje codziennie od 8:00 do 21:00.',
      rightsReserved: '© 2019 Flyo AS. All rights reserved.'
    }
  },
  routes: {
    url: {
      transferPage: '/:locale/transfer-oslo-gardermoen',
      aiportTransfer: '/:locale/transfer-oslo-gardermoen',
      booking: '/:locale/booking',
      kidsSafety: '/:locale/booking/kids-safety',
      flights: '/:locale/booking/flight',
      map: '/:locale/booking/map',
      userData: '/:locale/booking/user-data',
      confirmPhone: '/:locale/booking/confirm-phone',
      summary: '/:locale/booking/summary',
      confirmed: '/:locale/booking/confirmed',
      signup: '/:locale/signup',
      registrationStep1: '/:locale/registration-step-1',
      registrationStep2: '/:locale/registration-step-2',
      registrationStep3: '/:locale/registration-step-3',
      login: '/:locale/login',
      resetPassword: '/:locale/reset-password',
      dashboard: '/:locale/dashboard',
      dashboardEdit: '/:locale/dashboard/edit/:id',
      dashboardReservationPayment: '/:locale/dashboard/reservation-payment',
      help: '/:locale/help',
      accountTrips: '/:locale/account/my-trips',
      account: '/:locale/account',
      accountProfile: '/:locale/account/profile',
      accountCards: '/:locale/account/cards',
      accountPlaces: '/:locale/account/places',
      accountPlacesMap: '/:locale/account/map',
      accountInvoices: '/:locale/account/invoices',
      accountSettings: '/:locale/account/settings',

      home: '/pl',
      howItWorks: '/:locale/jak-dzialamy',
      prices: '/:locale/cennik',
      faq: '/:locale/pytania-i-odpowiedzi',
      contact: '/:locale/kontakt',
      termsAndConditions: '/:locale/regulamin',
      privacyPolicy: '/:locale/polityka-prywatnosci',
    },
    name: {
    }
  },
  test: { test: "hello" },
  errors: {
    notFound: {
      title: "404",
      content: "Ups! Nie mogliśmy znaleźć strony, której szukasz."
    }
  }
}
